import React from 'react';

import {
  LegacyText,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@gogame/components';

export const AdjustTable = ({ data }) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell width={'150px'}>Application</TableCell>
          <TableCell width={'90px'}>Android</TableCell>
          <TableCell>IOS</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map(({ appName = '', androidToken = '', iosToken = '' }, i) => {
          return (
            <TableRow key={i}>
              <TableCell width={'150px'}>
                <LegacyText>{appName}</LegacyText>
              </TableCell>
              <TableCell width={'90px'}>
                <LegacyText>{androidToken}</LegacyText>
              </TableCell>
              <TableCell>
                <LegacyText>{iosToken}</LegacyText>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
